/**
 * SectionPalette — lists available section types to add to the canvas.
 */
import React from 'react';
import {
  Box, Button, Divider, List, ListItem, ListItemButton, ListItemText, Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const SECTION_TYPES = [
  { type: 'header',       label: 'Header',           description: 'Practice logo, name, and address' },
  { type: 'customer',     label: 'Customer Info',     description: 'Patient name, DOB, address' },
  { type: 'items',        label: 'Line Items',        description: 'Products/services table' },
  { type: 'prescription', label: 'Prescription',      description: 'Rx details (OD/OS)' },
  { type: 'insurance',    label: 'Insurance/Claim',   description: 'Insurance details and codes' },
  { type: 'totals',       label: 'Totals',            description: 'Subtotal, tax, total, balance due' },
  { type: 'payments',     label: 'Payments',          description: 'Payment history' },
  { type: 'notes',        label: 'Notes / Text',      description: 'Free-text or token field' },
  { type: 'footer',       label: 'Footer',            description: 'Signature line, closing message' },
  { type: 'divider',      label: 'Divider',           description: 'Horizontal rule separator' },
  { type: 'spacer',       label: 'Spacer',            description: 'Vertical white space' },
];

export default function SectionPalette({ onAdd }) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ px: 1, pt: 1, pb: 0.5 }}>
        Sections
      </Typography>
      <Divider />
      <List dense disablePadding>
        {SECTION_TYPES.map((st) => (
          <ListItem
            key={st.type}
            disablePadding
            secondaryAction={
              <Button
                size="small"
                startIcon={<AddIcon />}
                onClick={() => onAdd(st)}
                sx={{ fontSize: '0.7rem', minWidth: 0, px: 1 }}
              >
                Add
              </Button>
            }
          >
            <ListItemButton dense sx={{ pr: 7 }}>
              <ListItemText
                primary={st.label}
                secondary={st.description}
                primaryTypographyProps={{ variant: 'body2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
